export default __webpack_public_path__ + "static/media/logo-election2024.de618003.svg";